import React from "react";
import { whyUslotContent } from "../../utils/data";
import { useTranslation } from "react-i18next";

const WhyUslot = () => {
  const { t } = useTranslation('home');

  return (
    <section className="m-12 md-small:m-0 md-small:rounded-none px-20 py-28 md-small::py-10 md-small:px-6 md-small::px-7 flex flex-col items-center gap-10 rounded-2xl">
      <div className="flex flex-col items-center gap-4">
        <p className="text-black text-4xl md-small::text-center">
          {t('whyUslot.title')}
        </p>
        <p className="text-[#00000080] text-base text-center max-w-2xl">
          {t('whyUslot.description')}
        </p>
      </div>
      <div className="grid grid-cols-3 md:md-max:grid-cols-2 md-small:grid-cols-1 gap-x-7 gap-y-14 md-small::gap-5">
        {t('whyUslot.cards', { returnObjects: true }).map((item) => (
          <div
            key={item.id}
            className="border border-blue-400 bg-white rounded-xl px-6 py-12 flex flex-col gap-4 md-small:shadow-xl hover:scale-110 duration-300"
          >
            <img src={item.icon} alt="icon" className="object-cover size-6" />
            <p className="text-gradient font-medium text-xl">{item.title}</p>
            <p className="text-[#1A428E] text-base ">{item.description}</p>
          </div>
        ))}
      </div>
    </section>
  );
};

export default WhyUslot;
